export default "__VITE_ASSET__DRISzDzr__"